export default __webpack_public_path__ + "static/NBInternationalPro-Mono-5bbabdb0a6c70953dbcbf1b7bb940fd5.otf";